declare const window: {
    // 业务方传入环境变量
    GENERAL_SSO_API_PASSPORT_PREFIX?: string; // passport接口的前缀
};

export const PASSPORT_PREFIX = {
    production: window?.GENERAL_SSO_API_PASSPORT_PREFIX || 'https://passport.kuaishou.com',
    development: 'https://account-login.webdev.test.gifshow.com',
}
